import React, { useEffect, useState } from 'react';
import Grid from '@mui/material/Grid';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import { LoadingButton } from '@mui/lab';
import { useNavigate } from 'react-router-dom';
import { getCustomerProfile } from '_models/redux/customer-profile/action';
import { connect } from 'react-redux';
import { useForm } from 'react-hook-form';
import { cleanGetProfile } from '../../../../../../_models/redux/customer-profile/clean';
import CircularProgress from '@mui/material/CircularProgress';

const Modal = (props) => {
  const { modalOpen, setOpenModal, customerProfileReducer, cleanGetProfile } = props || {};
  const { customerProfile, customerProfileStatus } = customerProfileReducer || {};
  const { response } = customerProfile || {};

  const [directNumber, setDirectNumber] = useState('');
  const [isLoading, setLoading] = useState(false);
  const [textError, setTextError] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isSubmitted && customerProfileStatus === 200 && directNumber) {
      cleanGetProfile();
      setLoading(false);
      navigate('/incidenciacliente', {
        state: { directNumber: directNumber },
      });
    }
  }, [customerProfileStatus, directNumber, isSubmitted, cleanGetProfile, navigate]);

  useEffect(() => {
    if (response?.status >= 300) {
      setLoading(false);
    }
  }, [response]);

  useEffect(() => {
    return () => {
      if (customerProfileStatus !== 200) {
        cleanGetProfile();
      }
    };
  }, [modalOpen, customerProfileStatus, cleanGetProfile]);

  const onInputChange = ({ target }) => {
    const { value } = target;
    setDirectNumber(value.replace(/\s+/g, ''));
    setTextError('');
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const registerOptions = {
    directNumber: {
      required: 'Número Dalefon es requerido',
      minLength: {
        value: 10,
        message: 'mínimo 10 caracteres',
      },
      maxLength: {
        value: 10,
        message: 'mínimo 10 caracteres',
      },
    },
  };

  const onSubmit = () => {
    setLoading(true);
    setIsSubmitted(true);
    props.getCustomerProfile({ directNumber: directNumber });
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Grid container className='modalBackground'>
        <Grid item size={{ xs: 4 }} className='modalContainer'>
          <Grid container className='title'>
            <Grid item size={{ xs: 9 }}>
              <h4>Buscar número telefónico</h4>
            </Grid>
            <Grid item size={{ xs: 3 }} className='titleCloseBtn'>
              <button
                type='button'
                onClick={() => {
                  setOpenModal(false);
                }}
              >
                <CloseIcon />
              </button>
            </Grid>
          </Grid>

          <Grid item size={{ xs: 12 }} className='body'>
            <TextField
              variant='standard'
              {...register('directNumber', registerOptions.directNumber)}
              helperText={textError}
              fullWidth
              type='text'
              className='form-control'
              placeholder='Número Dalefon a 10 dígitos'
              value={directNumber}
              onChange={onInputChange}
            />
          </Grid>
          <span>
            {errors?.directNumber && (
              <p className='required-incidence'>
                {errors.directNumber.message}
                {response?.data?.detail}
              </p>
            )}
          </span>
          <center>
            {isLoading ? (
              <CircularProgress />
            ) : response?.status >= 300 ? (
              <span className='required-incidence'>{response?.data?.detail}</span>
            ) : null}
          </center>

          <Grid item size={{ xs: 12 }} className='footer'>
            <button
              type='button'
              onClick={() => {
                setOpenModal(false);
              }}
              id='cancelBtn'
            >
              Cancelar
            </button>

            <LoadingButton
              size='small'
              type='submit'
              loading={isLoading}
              loadingPosition='end'
              variant='contained'
            >
              Buscar
            </LoadingButton>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};

const mapStateToProps = (state) => ({
  customerProfileReducer: state.customerProfile,
});
const mapDispatchToProps = {
  getCustomerProfile,
  cleanGetProfile,
};

export default connect(mapStateToProps, mapDispatchToProps)(Modal);
